<template>
    <template v-if="hasAccess">
        <slot />
    </template>
</template>
<script setup lang="ts">
import { toRefs } from "vue";
import { useHasAccess } from "../composables/use-has-access";

const props = defineProps({
    resource: String,
    action: String,
    featureId: String,
    externalContext: Object,
    ignoreConditions: Boolean,
});

const { externalContext } = toRefs(props);
const { hasAccess } = useHasAccess({ ...props, externalContext, featureID: props.featureId });
</script>
